import { createAction, props } from "@ngrx/store";

export const GET_ALL_AGENTS = '[Agents] Get All Agents';

export const ERROR = '[Agents] Error';

export const getAllAgents = createAction(GET_ALL_AGENTS);

export const error = createAction(ERROR, props<{error: string}>());